import { render } from "./EditProjects.vue?vue&type=template&id=f46fd7b2"
import script from "./EditProjects.vue?vue&type=script&lang=js"
export * from "./EditProjects.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__